/** Omit Stripe's checkout credential from URLs sent to analytics. */
export const sanitizeCheckoutSessionUrl = (href: string): string => {
  const url = new URL(href);
  if (!url.searchParams.has("checkout_session_id")) return href;
  url.searchParams.delete("checkout_session_id");
  return url.toString();
};
